import { FileClient, PageableResponse, RestClient } from "clients/rest";

export type B090051FindRequest = {
  torihikiYmdFrom: string;
  torihikiYmdTo: string;
  sokoCd: string;
  shohinCd: string;
} & Partial<{
  janCd: string;
  updDateFrom: string;
  updhourFrom: string;
  updminuteFrom: string;
  updDateTo: string;
  updhourTo: string;
  updminuteTo: string;
  updshainCd: string;
  ukeharaiKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B090051FindResponse = {
  crtDate: string;
  ukeharaiKbnNm: string;
  ukeiresu: string;
  haraidashisu: string;
  torihikiYmdView: string;
  aitesakisokoCd: string;
  aitesakisokoNm: string;
  locationCd: string;
  shainNm: string;
};

//検索処理
export const B090051Find = (props: B090051FindRequest) => {
  return RestClient.get<PageableResponse<B090051FindResponse[]>>(
    "b090051/find",
    {
      params: props,
    }
  );
};

//Excel出力処理
export const B090051GetExcel = (props: B090051FindRequest) => {
  return FileClient.get("b090051/get/excel", {
    params: props,
  });
};
